module.exports = __webpack_public_path__ + "img/virtacc.1bfdfada.svg";